export default __webpack_public_path__ + "static/media/1491.62dadd01.png";